import React from 'react';
import { CPS_CONTENT_TYPE_FIELD_TYPE } from '@cs-cms/types';
import { buildFieldMapperContext } from './fieldMapper/fieldMapperHelpers';
import {
  renderBoolField,
  renderChoiceField,
  renderDateField,
  renderMultiChoiceField,
  renderNumberField,
  renderTextLikeField
} from './fieldMapper/renderers';
import { FieldMapperProps } from './fieldMapper/fieldMapperTypes';

export type { FieldMapperProps } from './fieldMapper/fieldMapperTypes';

export const FieldMapper: React.FC<FieldMapperProps> = props => {
  const ctx = buildFieldMapperContext(props);

  switch (ctx.ctField.type) {
    case CPS_CONTENT_TYPE_FIELD_TYPE.BOOL:
      return renderBoolField(ctx);
    case CPS_CONTENT_TYPE_FIELD_TYPE.DATE:
    case CPS_CONTENT_TYPE_FIELD_TYPE.DATETIME:
      return renderDateField(ctx);
    case CPS_CONTENT_TYPE_FIELD_TYPE.DECIMAL:
    case CPS_CONTENT_TYPE_FIELD_TYPE.INT:
    case CPS_CONTENT_TYPE_FIELD_TYPE.INT64:
      return renderNumberField(ctx);
    case CPS_CONTENT_TYPE_FIELD_TYPE.CHOICE:
      return renderChoiceField(ctx);
    case CPS_CONTENT_TYPE_FIELD_TYPE.MULTI_CHOICE:
      return renderMultiChoiceField(ctx);
    default:
      return renderTextLikeField(ctx);
  }
};
